import { render, staticRenderFns } from "./PatientDetails.vue?vue&type=template&id=5b9d31ca&scoped=true&"
import script from "./PatientDetails.vue?vue&type=script&lang=js&"
export * from "./PatientDetails.vue?vue&type=script&lang=js&"
import style0 from "./PatientDetails.vue?vue&type=style&index=0&id=5b9d31ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9d31ca",
  null
  
)

export default component.exports